// import { Button } from '@components/common/form';
// import { Container } from 'react-bootstrap';
import React from 'react';
import USSD from '@components/screens/USSD';

// const { TextInput } = require('@components/common/form');
import { WebsiteLayout } from '@components/common/layout';

/**
 * header banner, spanning the width of the page. about
 */
const formInputStyleOverrides = { marginBottom: 15 };

function DevelopersPage({ logout, user }) {
  return (
    <WebsiteLayout navbarBackgroundColor="white" user={user} handleLogout={logout}>
      <USSD />
    </WebsiteLayout>
  );
}

export default DevelopersPage;
